"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var index_1 = __importDefault(require("../index"));
var DEFAULT_DECORATE_OPTIONS = function (o) { return o; };
function Preset(_a) {
    var _b = _a.decorateOptions, decorateOptions = _b === void 0 ? DEFAULT_DECORATE_OPTIONS : _b, Conductor = _a.Conductor, autorun = _a.autorun, onInit = _a.onInit, rest = __rest(_a, ["decorateOptions", "Conductor", "autorun", "onInit"]);
    var _c = __read((0, react_1.useState)(), 2), confetti = _c[0], setConfetti = _c[1];
    var initHandler = (0, react_1.useCallback)(function (_a) {
        var confettiInstance = _a.confetti;
        setConfetti(function () { return confettiInstance; });
    }, []);
    (0, react_1.useEffect)(function () {
        if (!confetti) {
            return;
        }
        var conductor = new Conductor({
            confetti: confetti,
            decorateOptions: decorateOptions,
        });
        if (autorun) {
            conductor.run(autorun);
        }
        onInit === null || onInit === void 0 ? void 0 : onInit({ confetti: confetti, conductor: conductor });
        return conductor.stop;
    }, [confetti]);
    return react_1.default.createElement(index_1.default, __assign({ onInit: initHandler }, rest));
}
exports.default = Preset;
